module.exports = __webpack_public_path__ + "static/media/67697557_665215883965031_1775289135112650752_o.fc6d0610.jpg";